export default "__VITE_ASSET__CH$wfXP6__"